import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface ServiceLatency { name: string; p50: number; p95: number; p99: number; history: Array<{ timestamp: string; latencyMs: number }>; }
export interface LatencyData { services: Record<string, ServiceLatency>; }

export function useLatency(hours = 24) {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [data, setData] = useState<LatencyData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<LatencyData>(`/api/dashboard/latency?hours=${hours}`, token)
      .then((d) => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, hours, refreshKey, logout]);

  return { data, loading };
}
